import { StandardEvents } from '@shopify/events';

const pendingNoteUpdates = new Set();
let lastEditedNote = null;

document.addEventListener('input', event => {
  const control = event.target;
  if (control?.matches?.('cart-note textarea[name="note"]')) lastEditedNote = control;
});

document.addEventListener(StandardEvents.cartNoteUpdate, event => {
  if (!event.promise) return;
  const pending = Promise.resolve(event.promise);
  pendingNoteUpdates.add(pending);
  pending.then(
    () => pendingNoteUpdates.delete(pending),
    () => pendingNoteUpdates.delete(pending)
  );
});

export function buildGiftNote(note, gift, card, cardCode) {
  if (!gift || !card || !cardCode) throw new Error('gift-selection');
  const customerNote = String(note ?? '')
    .replace(/\[MOKSH DEEPAM FREE GIFTS\][\s\S]*?\[\/MOKSH DEEPAM FREE GIFTS\]/g, '')
    .trim();
  const giftNote = [
    '[MOKSH DEEPAM FREE GIFTS]',
    'FREE GIFTS TO PACK (1 set per order)',
    'Sacred gift: ' + gift + ' x 1',
    'Devotional card: ' + card + ' (' + cardCode + ') x 1',
    '[/MOKSH DEEPAM FREE GIFTS]',
  ].join('\n');
  return customerNote ? customerNote + '\n\n' + giftNote : giftNote;
}

export function lockCustomerNote(form) {
  const control = form?.elements.namedItem('note') || lastEditedNote;
  const note = control && typeof control.value === 'string' ? control.value : undefined;
  const controls = Array.from(document.querySelectorAll('cart-note textarea[name="note"]'));
  const states = controls.map(input => input.readOnly);
  controls.forEach(input => { input.readOnly = true; });
  document.querySelectorAll('cart-note').forEach(component => component.updateCartNote?.cancel?.());
  return {
    note,
    async settle() {
      while (pendingNoteUpdates.size) {
        await Promise.allSettled(Array.from(pendingNoteUpdates));
      }
    },
    unlock() {
      controls.forEach((input, index) => { input.readOnly = states[index]; });
    },
  };
}

export async function saveGiftSelection(base, gift, card, cardCode, customerNote) {
  if (!gift || !card || !cardCode) throw new Error('gift-selection');
  const read = await fetch(base + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!read.ok) throw new Error('cart');
  let cart = await read.json();
  if (!cart.items.length) throw new Error('empty-cart');
  const giftKeys = ['FREE sacred gift', 'FREE devotional card'];
  const changeProperties = async (item, properties) => {
    const response = await fetch(base + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
    });
    if (!response.ok) throw new Error('gifts');
    return response.json();
  };
  let extraGiftItem;
  while ((extraGiftItem = cart.items.slice(1).find(item => giftKeys.some(key => item.properties?.[key])))) {
    const properties = { ...extraGiftItem.properties };
    giftKeys.forEach(key => { properties[key] = ''; });
    cart = await changeProperties(extraGiftItem, properties);
  }
  const firstItem = cart.items[0];
  const properties = {
    ...firstItem.properties,
    'FREE sacred gift': gift + ' (1 per order)',
    'FREE devotional card': card + ' (' + cardCode + ') (1 printed card per order)',
  };
  if (giftKeys.some(key => firstItem.properties?.[key] !== properties[key])) {
    cart = await changeProperties(firstItem, properties);
  }
  const note = buildGiftNote(customerNote ?? cart.note, gift, card, cardCode);
  const attributes = { ...cart.attributes, 'Free gift': gift, 'Devotional art card': card };
  const saved = await fetch(base + '/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes, note }),
  });
  if (!saved.ok) throw new Error('gift-note');
  const result = await saved.json();
  if (result.note !== note || result.attributes?.['Free gift'] !== gift || result.attributes?.['Devotional art card'] !== card) {
    throw new Error('gift-note');
  }
  return result;
}
